import { isEqual } from 'lodash';
import { catchError, of } from 'rxjs';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { MobileAuthService } from '../../services';
import { ToasterService } from '../../shared/services';

@Component({
  template: '',
})
export class MobileRecoverPasswordComponent implements OnInit {
  isButtonDisabled: boolean;
  forgotPasswordForm: FormGroup;

  constructor(
    protected navCtrl: NavController,
    protected formBuilder: FormBuilder,
    protected authService: MobileAuthService,
    protected translate: TranslateService,
    protected toasterService: ToasterService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    const initialValues = this.forgotPasswordForm.value;
    this.forgotPasswordForm.valueChanges.subscribe((ivalues) => {
      this.isButtonDisabled = isEqual(ivalues, initialValues);
    });
  }

  sendResetLink(): void {
    this.isButtonDisabled = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    }
    const subject = this.translate.instant('PASSWORD_RESET_REQUEST');
    this.authService
      .forgotPassword(this.forgotPasswordForm.get('email')?.value, subject)
      .pipe(
        catchError(() => {
          this.toasterService.error(this.translate.instant('NO_USER_WITH_THIS_EMAIL'));
          this.changeDetectorRef.markForCheck();
          return of(null);
        }),
      )
      .subscribe((response) => {
        if (response) {
          this.toasterService.success(this.translate.instant('PASSWORD_RESET_EMAIL_SENT'));
          this.navCtrl.navigateRoot('/');
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}
